import { render, staticRenderFns } from "./Rasio.vue?vue&type=template&id=7bfeab42&scoped=true"
import script from "./Rasio.vue?vue&type=script&lang=js"
export * from "./Rasio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfeab42",
  null
  
)

export default component.exports